import React from "react";
import { motion } from "framer-motion";
import CTAButton from "./CTAButton";
import { useSiteContent } from "../../hooks/useSiteContent";

export default function AboutMe() {
  const { content } = useSiteContent();
  return (
    <section id="sobre" className="py-24 lg:py-32 bg-card-gradient" data-testid="about-me">
      <div className="container grid lg:grid-cols-2 gap-16 items-center">
        <motion.div initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} className="relative max-w-[350px] mx-auto lg:mx-0">
          <video controls className="w-full aspect-[9/16] rounded-sm border border-primary/20 shadow-gold object-cover bg-black/20">
            <source src={content.about_video_src} type="video/mp4" />
            Seu navegador não suporta vídeos.
          </video>
        </motion.div>
        <motion.div initial={{ opacity: 0, x: 20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
          <div className="eyebrow mb-4"><span className="kicker-line" />Minha história</div>
          <h2 className="text-3xl lg:text-4xl font-display font-light mb-8">
            {content.about_title} <span className="italic text-gold-gradient">{content.about_title_highlight}</span>.
          </h2>
          <div className="space-y-5 text-muted-foreground leading-relaxed">
            <p>{content.about_p1}</p>
            <p>{content.about_p2}</p>
            <p>{content.about_p3}</p>
            <p>{content.about_p4}</p>
            <p className="text-foreground">{content.about_p5}</p>
          </div>

          <CTAButton className="!mt-8" />

          <div className="mt-12 flex items-center gap-8">
            <div><div className="font-display text-3xl text-gold-gradient">{content.about_stat1_value}</div><div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">{content.about_stat1_label}</div></div>
            <div className="w-px h-10 bg-border" />
            <div><div className="font-display text-3xl text-gold-gradient">{content.about_stat2_value}</div><div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">{content.about_stat2_label}</div></div>
            <div className="w-px h-10 bg-border" />
            <div><div className="font-display text-3xl text-gold-gradient">{content.about_stat3_value}</div><div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">{content.about_stat3_label}</div></div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
